<style scoped></style>
<template>
  <swiper-content isProduct :contentEnabled="contentEnabled">
    <swiper-slide>
      <div class="slide-content">
        <div class="page-layout page-layout-product">
          <div class="content clue">
            <h2>YOU'VE FOUND COIN NO.3</h2>
            <p>Congratulations! You’ve found all 3 hidden 5G coins!</p>
            <img src="airpods.png" style="max-height:30%;"/>
            <p>Enter your
            details now, and stand to win AirPods Pro worth $379!</p>
                        <a
              target="_blank"
              href="https://www.singtel.com/personal/products-services/mobile/eform/iphone_singtelgame?utm_source=virtual-store&utm_medium=virtual-store&utm_term=apple&utm_content=coin-hunt-game&utm_campaign=iphone-2020-launch"
              class="st-button-red-outline page-button"
            >
              Submit My Details
            </a>
          </div>
        </div>
      </div>
    </swiper-slide>
  </swiper-content>
</template>

<script>
import "swiper/swiper-bundle.css";

export default {
  name: "Coin3Page",
  data: function () {
    return {};
  },
  props: {
    contentEnabled: Boolean,
  },
  methods: {},
};
</script>

<style scoped></style>
